import chairIcon from '../Assets/Items-Shapes/OfficeChair-icon.svg';
import plantIcon from '../Assets/Items-Shapes/Plants-icon.svg';
import singleSofaIcon1 from '../Assets/Items-Shapes/sofa 1 seater-icon.svg';
import singleSofaIcon2 from '../Assets/Items-Shapes/sofa 2 seater-icon.svg';
import singleSofaIcon3 from '../Assets/Items-Shapes/sofa 3 seater-icon.svg';
import singleSofaIcon7 from '../Assets/Items-Shapes/sofa 7 seater-icon.svg';
import splitAcIcon from '../Assets/Items-Shapes/Ac Spilt-icon.svg';
import standingAcIcon from '../Assets/Items-Shapes/Ac Standing-icon.svg';
import tvIcon from '../Assets/Items-Shapes/TV-ic.svg';
import deskIcon1 from '../Assets/Items-Shapes/desk 1 person-icon.svg';
import deskIcon2 from '../Assets/Items-Shapes/desk 2 person-icon.svg';
import deskIcon4 from '../Assets/Items-Shapes/desk 4 person-icon.svg';
import deskIcon6 from '../Assets/Items-Shapes/desk 6 person-icon.svg';
import desktopIcon from '../Assets/Items-Shapes/desktop-ic.svg';
import laptopIcon from '../Assets/Items-Shapes/laptop-ic.svg';
import showerIcon from '../Assets/Items-Shapes/shower-ic.svg';
import sinkIcon from '../Assets/Items-Shapes/sink-ic.svg';
import toiletIcon from '../Assets/Items-Shapes/toilet-ic.svg';

export const ItemsEnum = {
    Chair: { title: 'Chair', icon: chairIcon },
    Plant: { title: 'Plant', icon: plantIcon },
    SingleSofa1Seater: { title: 'Single Sofa 1 Seater', icon: singleSofaIcon1 },
    SingleSofa2Seater: { title: 'Single Sofa 2 Seater', icon: singleSofaIcon2 },
    SingleSofa3Seater: { title: 'Single Sofa 3 Seater', icon: singleSofaIcon3 },
    SingleSofa7Seater: { title: 'Single Sofa 7 Seater', icon: singleSofaIcon7 },
    SplitAC: { title: 'Split AC', icon: splitAcIcon },
    StandingAC: { title: 'Standing AC', icon: standingAcIcon },
    TV: { title: 'TV', icon: tvIcon },
    Desk1Person: { title: 'Desk 1 Person', icon: deskIcon1 },
    Desk2Person: { title: 'Desk 2 Person', icon: deskIcon2 },
    Desk4Person: { title: 'Desk 4 Person', icon: deskIcon4 },
    Desk6Person: { title: 'Desk 6 Person', icon: deskIcon6 },
    Desktop: { title: 'Desktop', icon: desktopIcon },
    Laptop: { title: 'Laptop', icon: laptopIcon },
    Shower: { title: 'Shower', icon: showerIcon },
    Sink: { title: 'Sink', icon: sinkIcon },
    Toilet: { title: 'Toilet', icon: toiletIcon },
};